import { render, staticRenderFns } from "./DashboardLayoutMenu.vue?vue&type=template&id=c6ad4b3e&scoped=true&"
import script from "./DashboardLayoutMenu.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayoutMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLayoutMenu.vue?vue&type=style&index=0&id=c6ad4b3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ad4b3e",
  null
  
)

export default component.exports